<template>
  <div></div>
</template>

<script>
export default {
  name: "RwvFooter"
};
</script>
